// extracted by mini-css-extract-plugin
export var banner = "_rs-0";
export var settingRow = "_rs-2";
export var titleIcon = "_rs-1";